import { Outlet } from 'react-router-dom';
import BottomNav from './BottomNav.jsx';
import CrossAppBar from './CrossAppBar.jsx';

export default function DashboardLayout() {
  return (
    <div className="min-h-full bg-slate-50">
      <CrossAppBar />
      <main className="mx-auto max-w-6xl px-4 pt-6 pb-24 sm:px-6">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
